import jsPDF from "jspdf";
import { loadAndAddFonts } from "../../../../PDFsFunctions/fontsPDF";
import { centeredText, getStyle } from "../../../../PDFsFunctions/textUtilsPDF";
import { colors, fontSize } from "../../../../PDFsFunctions/configPDF";

function normalizePayments(receipt) {

    const amounts = receipt.amount
        .split(",")
        .map(v => parseFloat(v.replace("$", "").trim()));

    let methods = receipt.payment_method;

    // si solo viene un método pero hay varios montos
    if (methods.length === 1 && amounts.length > 1) {
        methods = new Array(amounts.length).fill(methods[0]);
    }

    const grouped = {};

    methods.forEach((m, i) => {

        const method = m.toLowerCase();
        const amount = amounts[i] || 0;

        if (!grouped[method]) grouped[method] = 0;

        grouped[method] += amount;

    });

    return grouped;
}
const CashAuditPDF = async (auditData) => {

    const margins = { left: 2, right: 2, top: 4 };
    const lineBreak = 4;

    const lines = [];
    const payments = {
        cash: [],
        debit: [],
        credit: [],
        transfer: []
    };
    const receipts = auditData.receipts_review.current;
    const usdRate = parseFloat(auditData.average_usd_exchange_rate);

    const format = (value) => parseFloat(value).toFixed(2);

    const addLine = (text = "", style = "normal", align = "left", size = 8) => {
        lines.push({ text: String(text), style, align, size });
    };

    const addKV = (label, value, style = "normal", size = 8) => {
        lines.push({
            type: "kv",
            label: String(label),
            value: String(value),
            style,
            size
        });
    };

    const section = (title) => {
        addLine("");
        addLine(title, "bold", "left", 10);
    };
    receipts.forEach(receipt => {

        if (receipt.st === "CANCELLED") return;

        const normalized = normalizePayments(receipt);

        Object.entries(normalized).forEach(([method, amount]) => {

            let finalAmount = amount;

            if (method.includes("usd")) {
                finalAmount = amount * usdRate;
            }

            const item = {
                id: receipt.id,
                date: receipt.date_time,
                amount: finalAmount
            };

            if (method.includes("efectivo")) payments.cash.push(item);
            else if (method.includes("debito")) payments.debit.push(item);
            else if (method.includes("credito")) payments.credit.push(item);
            else if (method.includes("transfer")) payments.transfer.push(item);

        });

    });


    const cancelled = [];
    const refunded = [];
    const normal = [];

    receipts.forEach(r => {

        if (r.st === "CANCELLED") {
            cancelled.push(r);
            return;
        }

        if (r.has_refund) {
            refunded.push(r);
            return;
        }

        normal.push(r);

    });

    const refundedFromOtherCashAudit = auditData.receipts_review.refundedFromOtherCashAudit || [];

    // ======================
    // CONTENIDO
    // ======================
    addLine("");
    addLine("CORTE DE CAJA", "bold", "center", 12);
    addLine("--------------------------------------------------");

    addLine("FOLIO: " + auditData.folio);
    addLine("Recepcionista: " + auditData.receptionist.name);

    addLine("Sucursal: " + auditData.subsidiary_name);
    addLine("Fecha/Hora de corte: " + auditData.date_time);

    addLine("--------------------------------------------------");

    section("EFECTIVO EN SISTEMA");

    addKV("MXN: ", format(auditData.cash_mxn));
    addKV(`USD (${format(auditData.cash_usd)}):`, `MXN ${format(auditData.usd_to_mxn)}`);

    addKV(
        "Total Efectivo Sistema: ",
        format(parseFloat(auditData.usd_to_mxn) + parseFloat(auditData.cash_mxn))
    );

    section("EFECTIVO REAL");
    addKV("MXN: ", format(auditData.cash_mxn_received));

    addKV(
        `USD (${format(auditData.cash_usd_received)}): `, `MXN ${parseFloat(auditData.cash_usd_received) *
        parseFloat(auditData.average_usd_exchange_rate)
        }`
    );

    addKV(
        "Total Efectivo Real: ",
        format((
            (parseFloat(auditData.cash_usd_received) *
                parseFloat(auditData.average_usd_exchange_rate) +
                parseFloat(auditData.cash_mxn_received)
            ).toFixed(2)
        )));

    section("PAGOS ELECTRÓNICOS");

    addKV("Total Débito", format(auditData.card_debit_total));
    addKV("Total Crédito", format(auditData.card_credit_total));
    addKV("Total transferencia", format(auditData.transfer_total));


    section("REEMBOLSOS");
    addKV("Total reembolsado", format(auditData.total_cash_refunds));


    addLine("--------------------------------------------------");

    addKV("Importe total", "$" + format(auditData.total_amount_received), "bold", 12);
    addKV("Total en sistema", format(auditData.total_amount), "", 9);
    addKV("Descuadre", format(auditData.discrepancy), "", 9);
    addLine("--------------------------------------------------");

    section("DETALLE DE RECIBOS");
    addKV('Recibo     Fecha/Hora', 'Importe', "bold");

    //
    if (payments.cash.length >= 1) {
        addLine("EFECTIVO")
        payments.cash.forEach(r => {
            addKV(r.id + "    " + r.date, format(r.amount), "", 7);
        });
    }
    //
    if (payments.debit.length >= 1) {
        addLine("--------------------------------------------------");
        addLine("DEBITO")
        payments.debit.forEach(r => {
            addKV(r.id + "    " + r.date, format(r.amount), "", 7);
        });
    }
    //
    if (payments.credit.length >= 1) {
        addLine("--------------------------------------------------");
        addLine("CREDITO")
        payments.credit.forEach(r => {
            addKV(r.id + "    " + r.date, format(r.amount), "", 7);
        });
    }
    if (payments.transfer.length >= 1) {
        addLine("--------------------------------------------------");
        addLine("TRANSFERENCIA");
        payments.transfer.forEach(r => {
            addKV(r.id + "    " + r.date, format(r.amount), "", 7);
        });
    }


    addLine("--------------------------------------------------");
    if (cancelled.length >= 1) {
        section("RECIBOS CANCELADOS");

        Object.values(payments).forEach(list =>
            list.sort((a, b) => new Date(a.date) - new Date(b.date))
        );
        cancelled.forEach(r => {
            addKV(
                r.id + "    " + r.date_time,
                "0.00",
                "",
                7
            );

        });
    }
    if (refunded.length >= 1) {
        section("REEMBOLSOS");
        refunded.forEach(r => {

            addKV(
                r.id + "    " + r.date_time,
                r.refunded_amount.toFixed(2),
                "",
                7
            );

        });
    }
    if (refundedFromOtherCashAudit.length >= 1) {
        section("REEMBOLSOS DE OTRO CORTE");
        refundedFromOtherCashAudit.forEach(r => {

            addKV(
                r.id + "    " + r.date_time,
                r.refunded_amount.toFixed(2),
                "",
                7
            );

        });
    }

    section("LIBROS VENDIDOS");

    addLine("Escriba con número cuantos de c/u", "normal", "left", 7);

    const adultsBooks = ["Journey", "Explore", "Discover", "New Horizons"];
    const kidsBooks = [1, 2, 3, 4, 5, 6, 7];

    const colWidth = 18; // ancho de columna izquierda aprox

    // encabezado
    addLine(
        "Niños".padEnd(colWidth) + "Adultos",
        "bold",
        "left",
        7
    );

    const maxRows = Math.max(adultsBooks.length, kidsBooks.length);

    for (let i = 0; i < maxRows; i++) {

        const right = adultsBooks[i] ? "__ " + adultsBooks[i] : "";
        const left = kidsBooks[i] ? "__ " + kidsBooks[i] : "";

        addLine(
            left.padEnd(colWidth) + right,
            "normal",
            "left",
            7
        );

    }

    addLine("");
    addLine("Cantidad ingreso: $________________");
    addLine("");

    addLine("OBSERVACIONES");
    addLine("_______________________________");
    addLine("_______________________________");
    addLine("_______________________________");

    // addLine("Promociones aplicadas: " + auditData.discounts.amount);

    // if (auditData.discounts.autorized) {
    //     addLine("Autorización: " + auditData.discounts.autorized.name);
    // }

    // ======================
    // PDF TEMPORAL (medir altura)
    // ======================

    const tempPDF = new jsPDF({
        unit: "mm",
        format: [48, 500]
    });

    await loadAndAddFonts(tempPDF);

    getStyle(tempPDF, "normal", "#000", 8, "Calibri");

    const contentWidth =
        tempPDF.internal.pageSize.getWidth() - margins.left - margins.right;

    let y = margins.top;

    lines.forEach(line => {

        const split = tempPDF.splitTextToSize(line.text, contentWidth);

        y += split.length * lineBreak;

    });

    const finalHeight = y;

    // ======================
    // PDF FINAL
    // ======================

    const pdf = new jsPDF({
        unit: "mm",
        format: [48, finalHeight]
    });

    await loadAndAddFonts(pdf);

    const pageWidth = pdf.internal.pageSize.getWidth();

    let currentY = margins.top;

    lines.forEach(line => {

        getStyle(pdf, line.style || "normal", "#000", line.size || 8, "Calibri");

        if (line.type === "kv") {
            const left = line.label;
            const right = line.value;

            const rightWidth = pdf.getTextWidth(right);

            const xLeft = margins.left;
            const xRight = pageWidth - margins.right - rightWidth;

            pdf.text(left, xLeft, currentY);
            pdf.text(right, xRight, currentY);

            if (line.size < 8) {
                currentY += lineBreak * .7
            } else currentY += lineBreak;

            return;
        }

        const split = pdf.splitTextToSize(line.text, contentWidth);

        split.forEach(txt => {

            let x = margins.left;

            if (line.align === "center") {
                x = centeredText(pdf, pageWidth, txt);
            }

            pdf.text(txt, x, currentY);

            if (line.size < 8) {
                currentY += lineBreak * .7
            } else currentY += lineBreak;

        });

    });

    return pdf;
};

export default CashAuditPDF;